/**
 * 16kHz mono PCM を 24kHz へ線形補間でアップサンプルする純関数。
 * OpenAI transcription session が 24kHz PCM を要求するため (spec D4)。入力は VAD の 16kHz mono。
 *
 * 出力長 = floor(n * 3 / 2) は**デュレーションを保存する** (16kHz の n サンプル = n/16000 秒 が、
 * 24kHz でも同じ長さになる)。端点を共有する floor((n-1)*3/2)+1 は 1 サンプル短くなり、
 * ソース位置の刻みも 2/3 からずれるので採らない。React も Web Audio も知らない。
 *
 * 呼び出しは sendAudio の 1 箇所だけで、渡ってくるのは VAD の 512 サンプルフレームではなく
 * onSpeechEnd が返す**発話まるごと**の Float32Array (チャンク分割して呼ばれることはない)。
 */
export function upsample16kTo24k(pcm: Float32Array): Float32Array {
  const n = pcm.length;
  const outLen = Math.floor((n * 3) / 2);
  const out = new Float32Array(outLen);
  for (let i = 0; i < outLen; i++) {
    // 出力位置 i のソース位置。末尾は範囲外を読まず最終サンプルへ clamp する
    const src = (i * 2) / 3;
    const idx = Math.floor(src);
    const frac = src - idx;
    out[i] = pcm[idx] * (1 - frac) + pcm[Math.min(idx + 1, n - 1)] * frac;
  }
  return out;
}
